export default function verifyValidText(value) {
  return value && value.trim() !== "" && value.length > 0;
}
